/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */

/* eslint-disable react/no-unused-prop-types */

/* eslint-disable react/display-name */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import * as React from 'react';
import { List, Set as ImmutableSet, OrderedMap } from 'immutable';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UISelect from 'UIComponents/input/UISelect';
import UIMedia from 'UIComponents/layout/UIMedia';
import UIMediaLeft from 'UIComponents/layout/UIMediaLeft';
import UIMediaBody from 'UIComponents/layout/UIMediaBody';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import Networks from '../../lib/Networks';
import UILock from 'ui-addon-upgrades/icons/UILock';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import UILink from 'UIComponents/link/UILink';
import AdAccountStatus from '../../lib/AdAccountStatus';
import UIStatusTag from 'UIComponents/tag/UIStatusTag';
import { InactiveMessage, PermissionsMessage } from '../AccountPermissionsMessaging';
import PortalIdParser from 'PortalIdParser';

const getPixelUniqueId = pixel => `${pixel.adNetwork},${pixel.accountId},${pixel.id}`;

const onClickError = (type, trackEvent) => () => {
  if (trackEvent) {
    trackEvent('errorAction', {
      type,
      action: 'clicked kb link'
    });
  }
};

const withUMSHookHOC = Component => {
  return props => {
    const {
      openUpgradeModal
    } = useUpgradeModal('ads-pixel-select-dropdown');
    return /*#__PURE__*/_jsx(Component, Object.assign({
      openUpgradeModal: openUpgradeModal
    }, props));
  };
};

const getPixelErrors = (pixelAdAccount, trackEvent) => ({
  InactiveAccount: {
    statusTag: /*#__PURE__*/_jsx(UIStatusTag, {
      use: "danger",
      className: "display-block",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ADS_ACCOUNT_CONNECTION.permissions.inactive"
      })
    }),
    disabled: true,
    tooltip: /*#__PURE__*/_jsx(InactiveMessage, {
      adAccount: pixelAdAccount,
      onClick: onClickError('inactive', trackEvent)
    }),
    type: 'inactive'
  },
  NeedsPermissions: {
    statusTag: /*#__PURE__*/_jsx(UIStatusTag, {
      use: "danger",
      className: "display-block",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ADS_ACCOUNT_CONNECTION.permissions.permissionsNeeded"
      })
    }),
    disabled: true,
    tooltip: /*#__PURE__*/_jsx(PermissionsMessage, {
      adAccount: pixelAdAccount,
      onClick: onClickError('permissions', trackEvent)
    }),
    type: 'permissions'
  },
  AudiencePermissions: {
    statusTag: /*#__PURE__*/_jsx(UIStatusTag, {
      use: "danger",
      className: "display-block",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ADS_ACCOUNT_CONNECTION.permissions.permissionsNeeded"
      })
    }),
    disabled: true,
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.audiences.installPixelModal.disabledPixelTooltip.missingAudiencePermissions",
      options: {
        network: I18n.text(`ADS_ACCOUNT_CONNECTION.networks.${pixelAdAccount && pixelAdAccount.network.toLowerCase()}`)
      }
    }),
    type: 'permissions'
  },
  AccountPermissions: {
    statusTag: /*#__PURE__*/_jsx(UIStatusTag, {
      use: "danger",
      className: "display-block",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ADS_ACCOUNT_CONNECTION.permissions.permissionsNeeded"
      })
    }),
    disabled: true,
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.audiences.installPixelModal.disabledPixelTooltip.missingAccountPermissions",
      options: {
        network: I18n.text(`ADS_ACCOUNT_CONNECTION.networks.${pixelAdAccount && pixelAdAccount.network.toLowerCase()}`)
      }
    }),
    type: 'permissions'
  },
  CurrentUserNotConnected: {
    statusTag: /*#__PURE__*/_jsx(UIStatusTag, {
      use: "active",
      className: "display-block",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ADS_ACCOUNT_CONNECTION.permissions.active"
      })
    }),
    disabled: true,
    tooltip: /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "ADS_ACCOUNT_CONNECTION.audiences.installPixelModal.currentUserNotConnected.message",
        options: {
          network: I18n.text(`ADS_ACCOUNT_CONNECTION.networks.${pixelAdAccount && pixelAdAccount.network.toLowerCase()}`)
        }
      }), ' ', /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: `/settings/${PortalIdParser.get()}/marketing/ads/adAccounts`,
        onClick: e => e.stopPropagation(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ADS_ACCOUNT_CONNECTION.audiences.installPixelModal.currentUserNotConnected.link",
          options: {
            network: I18n.text(`ADS_ACCOUNT_CONNECTION.networks.${pixelAdAccount && pixelAdAccount.network.toLowerCase()}`)
          }
        })
      })]
    }),
    type: 'user-not-authed'
  }
});

const getPixelText = (pixel, network, pixelAdAccount) => {
  if (pixel.installed && !pixel.accessible) {
    // If an installed pixel has become inaccessible, the name isn't available,
    // so just use the id and inform the user about a permissions issue.
    return I18n.text('ADS_ACCOUNT_CONNECTION.audiences.pixels.installedPixelOption', {
      pixelId: pixel.id
    });
  }

  switch (network) {
    case Networks.FACEBOOK:
      return pixel.name;

    case Networks.ADWORDS:
      return pixelAdAccount ? pixelAdAccount.getDisplayName() : pixel.accountId;

    case Networks.LINKEDIN:
      return pixelAdAccount ? pixelAdAccount.accountName : pixel.accountId;

    default:
      return pixel.name;
  }
};

const LockedNetworkTooltip = openUpgradeModal => {
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.audiences.website.limitReached"
    }), ' ', /*#__PURE__*/_jsxs(UILink, {
      onClick: openUpgradeModal,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "ADS_ACCOUNT_CONNECTION.audiences.website.learnMore"
      }), /*#__PURE__*/_jsx(UILock, {
        style: {
          display: 'none'
        }
      })]
    })]
  });
};

const PixelTextSubText = ({
  text,
  subtext
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [text, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Small, {
    children: subtext
  })]
});

const PixelItemLabel = (onChange, NetworkIcon, openUpgradeModal) => option => {
  const {
    networkLocked,
    subtext,
    tooltip,
    statusTag,
    type,
    trackEvent,
    pixel
  } = option;

  if (pixel) {
    return /*#__PURE__*/_jsx(UITooltip, {
      title: tooltip,
      disabled: !option.disabled && !networkLocked,
      onOpenChange: e => {
        if (e.target.value && trackEvent && type) {
          trackEvent('errorDisplay', {
            type,
            form: 'tooltip'
          });
        }
      },
      onClick: networkLocked ? openUpgradeModal : undefined,
      children: /*#__PURE__*/_jsx(UICheckbox, {
        disabled: option.disabled || networkLocked,
        checked: option.checked,
        className: "m-all-3",
        alignment: "center",
        onChange: () => {
          onChange(pixel);
        },
        onClick: networkLocked ? openUpgradeModal : e => {
          e.preventDefault();

          if (!option.disabled && !networkLocked) {
            onChange(pixel);
          }
        },
        "data-test-id": `${pixel.adNetwork}-${pixel.id}`,
        title: `${pixel.adNetwork}-${pixel.id}`,
        children: networkLocked ? /*#__PURE__*/_jsxs("span", {
          children: [option.text, " ", /*#__PURE__*/_jsx(UILock, {
            className: "m-left-2"
          })]
        }) : statusTag ? /*#__PURE__*/_jsxs("div", {
          className: "m-y-2",
          children: [/*#__PURE__*/_jsx(PixelTextSubText, {
            text: option.text,
            subtext: subtext
          }), statusTag]
        }) : /*#__PURE__*/_jsx(PixelTextSubText, {
          text: option.text,
          subtext: subtext
        })
      })
    });
  } else {
    return /*#__PURE__*/_jsxs(UIMedia, {
      align: "center",
      className: "m-left-3",
      onClick: networkLocked ? openUpgradeModal : undefined,
      children: [/*#__PURE__*/_jsx(UIMediaLeft, {
        children: /*#__PURE__*/_jsx(NetworkIcon, {
          network: option.network,
          size: 20
        })
      }), /*#__PURE__*/_jsx(UIMediaBody, {
        className: "m-left-2",
        children: /*#__PURE__*/_jsx(UITooltip, {
          disabled: !networkLocked,
          title: /*#__PURE__*/_jsx(LockedNetworkTooltip, {
            openUpgradeModal: openUpgradeModal
          }),
          children: /*#__PURE__*/_jsxs("span", {
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: `ADS_ACCOUNT_CONNECTION.networks.${option.text.toLowerCase()}`
            }), networkLocked && /*#__PURE__*/_jsx(UILock, {
              className: "m-left-2"
            })]
          })
        })
      })]
    });
  }
};

const pixelValueRenderer = (selectedPixels, adAccounts, NetworkIcon) => {
  const PixelValue = ({
    value
  }) => {
    const pixel = selectedPixels.find(p => getPixelUniqueId(p) === value);
    const pixelAdAccount = adAccounts.find(adAccount => adAccount.network === pixel.adNetwork && adAccount.accountId === pixel.accountId);
    const subtext = pixel.adNetwork === Networks.FACEBOOK && pixelAdAccount ? pixelAdAccount.getDisplayName() : null;
    return /*#__PURE__*/_jsxs(UIMedia, {
      align: "center",
      className: "m-y-1",
      children: [/*#__PURE__*/_jsx(UIMediaLeft, {
        children: /*#__PURE__*/_jsx(NetworkIcon, {
          network: pixel.adNetwork,
          size: 20
        })
      }), /*#__PURE__*/_jsxs(UIMediaBody, {
        className: "m-left-2",
        children: [subtext ? `${subtext}: ` : '', getPixelText(pixel, pixel.adNetwork, pixelAdAccount)]
      })]
    });
  };

  return PixelValue;
};

const PixelSelectTooltip = ({
  networkLocked,
  alreadyInstalled,
  openUpgradeModal
}) => {
  if (networkLocked) {
    return /*#__PURE__*/_jsx(LockedNetworkTooltip, {
      openUpgradeModal: openUpgradeModal
    });
  }

  if (alreadyInstalled) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.audiences.installPixelModal.disabledPixelTooltip.pixelAlreadyInstalled"
    });
  }

  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "ADS_ACCOUNT_CONNECTION.audiences.installPixelModal.disabledPixelTooltip.alreadyInstalled"
  });
};

class PixelSelect extends React.PureComponent {
  getOptions() {
    const {
      adAccounts,
      pixelsByNetwork,
      selectedPixels,
      disableInstalled,
      enabledNetworks,
      trackEvent,
      requireAudiencePermissions = false,
      requireAudiencePermissionsToInstall = false,
      openUpgradeModal
    } = this.props;

    if (!pixelsByNetwork) {
      return [];
    }

    return pixelsByNetwork.map((pixels, network) => {
      const networkLocked = enabledNetworks ? !enabledNetworks.has(network) : false;
      return {
        text: network,
        network,
        networkLocked,
        options: pixels.map(pixel => {
          const pixelAdAccount = adAccounts.find(adAccount => adAccount.network === pixel.adNetwork && adAccount.accountId === pixel.accountId);
          const errorData = pixelAdAccount ? getPixelErrors(pixelAdAccount, trackEvent) : {};
          const inactive = pixelAdAccount && pixelAdAccount.status !== AdAccountStatus.ACTIVE;
          const accountInaccessible = pixelAdAccount && !pixelAdAccount.accessible && !pixelAdAccount.accessibleToPrimaryUser;
          const currentUserNotConnected = pixelAdAccount && !pixelAdAccount.currentUserHasConnected;
          const audiencePermissionsError = requireAudiencePermissions && pixelAdAccount && !pixelAdAccount.canCreateAudiences;
          const accountPermissionsError = requireAudiencePermissionsToInstall && disableInstalled && !pixel.installed && pixelAdAccount && !pixelAdAccount.canCreateAudiences;
          const errors = inactive ? errorData.InactiveAccount : accountInaccessible ? errorData.NeedsPermissions : currentUserNotConnected ? errorData.CurrentUserNotConnected : audiencePermissionsError ? errorData.AudiencePermissions : accountPermissionsError ? errorData.AccountPermissions : {};
          return Object.assign({
            text: getPixelText(pixel, network, pixelAdAccount),
            subtext: network === Networks.FACEBOOK && pixelAdAccount ? pixelAdAccount.getDisplayName() : null,
            value: getPixelUniqueId(pixel),
            pixel,
            checked: selectedPixels.has(pixel) || disableInstalled && pixel.installed,
            networkLocked,
            tooltip: /*#__PURE__*/_jsx(PixelSelectTooltip, {
              networkLocked: networkLocked,
              alreadyInstalled: disableInstalled && pixel.installed,
              openUpgradeModal: openUpgradeModal
            }),
            disabled: !pixel.accessible || disableInstalled && pixel.installed || networkLocked,
            trackEvent
          }, errors);
        }).toArray()
      };
    }).toArray();
  }

  onChange(pixel) {
    const {
      selectedPixels
    } = this.props;

    if (selectedPixels.has(pixel)) {
      this.props.onPixelChange(selectedPixels.delete(pixel));
    } else {
      this.props.onPixelChange(selectedPixels.add(pixel));
    }
  }

  onSelectedOptionChange(e) {
    // UISelect wants to make the same pixel selectable multiple times.
    // We turn that into turning the pixel check off.
    this.props.onPixelChange(List(e.target.value).filter(ee => !ee.disabled).groupBy(ee => ee.pixel).filter(ee => ee.size === 1).keySeq().toSet());
  }

  render() {
    const {
      NetworkIcon,
      adAccounts,
      dropdownFooter,
      selectedPixels,
      openUpgradeModal
    } = this.props;
    const pixelsByNetwork = this.getOptions();
    return /*#__PURE__*/_jsx(UISelect, {
      options: pixelsByNetwork,
      multi: true,
      onSelectedOptionChange: this.onSelectedOptionChange.bind(this),
      searchable: false,
      optionRenderer: PixelItemLabel(this.onChange.bind(this), NetworkIcon, openUpgradeModal),
      valueRenderer: pixelValueRenderer(selectedPixels, adAccounts, NetworkIcon),
      value: selectedPixels.map(pixel => getPixelUniqueId(pixel)).toArray(),
      filterOptions: false,
      placeholder: I18n.text('ADS_ACCOUNT_CONNECTION.audiences.pixels.selectPixelPlaceholder'),
      dropdownFooter: dropdownFooter,
      className: "pixel-select",
      anchorType: "button"
    });
  }

} // We don't have react-immutable-proptypes in this repo.
// Expected fields on ad account object:
//  accountName: string
//  accountId: string
//  network: string
//  status: string
//  accessible: string or accessibleToPrimaryUser: string
//  getDisplayName(): function, returns string
//  currentUserHasConnected: boolean


PixelSelect.propTypes = {
  NetworkIcon: PropTypes.func.isRequired,
  adAccounts: PropTypes.instanceOf(List).isRequired,
  disableInstalled: PropTypes.bool.isRequired,
  dropdownFooter: PropTypes.node,
  enabledNetworks: PropTypes.instanceOf(ImmutableSet),
  onPixelChange: PropTypes.func.isRequired,
  pixelsByNetwork: PropTypes.instanceOf(OrderedMap).isRequired,
  selectedPixels: PropTypes.instanceOf(ImmutableSet).isRequired,
  screen: PropTypes.string,
  openUpgradeModal: PropTypes.func
};
export default withUMSHookHOC(PixelSelect);